import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import {
    LogoButton,
    ProviderLogo
} from "@/components/signup/account-creation/components/social/components";
import { type SocialProvider } from "@/components/signup/utils";

import { useAccountSigninContext } from "../hooks/account-signin-context";

export const Social = ({
    providers
}: {
    providers?: { [K in SocialProvider]?: string };
}) => {
    const intl = useIntl();
    const { onClickSocialButton } = useAccountSigninContext();

    if (providers === undefined) {
        providers = {
            google: "Google",
            microsoft: "Microsoft",
            apple: "Apple",
            slack: "Slack"
        };
    }

    const buttons = Object.entries(providers);

    const buttonGridCss = css({
        display: "grid",
        gap: "16px",
        gridTemplateColumns: "repeat(2, 1fr)"
    });

    const buttonListCss = css({
        listStyle: "none",
        margin: 0,
        padding: 0
    });

    /* eslint-disable jsx-a11y/no-redundant-roles */
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */
    return (
        <ul
            css={[buttonListCss, buttons.length > 1 && buttonGridCss]}
            role="list"
        >
            {buttons.map(([provider, label]) => (
                <li key={provider}>
                    <LogoButton
                        aria-label={intl.formatMessage(
                            {
                                id: "social.label.signin",
                                defaultMessage: "sign in with {provider}"
                            },
                            {
                                provider: label
                            }
                        )}
                        onClick={() => onClickSocialButton(provider)}
                    >
                        <ProviderLogo logo={provider} />
                        <span>{label}</span>
                    </LogoButton>
                </li>
            ))}
        </ul>
    );
};
